export const WATCH_LISTS_STATE_KEY = 'watchLists';
